import { isMounted as a } from "@sunrise/shared";
import { track as r, NOT_SET as e, ElementTrackingIds as s } from "@sunrise/tracking";
import { defineComponent as l, computed as m } from "vue";
import { useHeaderStore as _ } from "./index4.js";
import i from "./index11.js";
import c from "./index181.js";
const O = l({
  name: "MsHeaderBookmark",
  components: {
    CsBookmarkIcon: i,
    MsModal: c
  },
  setup() {
    const t = _(), o = a(), n = m(() => o.value && !!t.amount);
    return {
      amount: m(() => o.value ? t.amount : 0),
      onClick: () => {
        t.$patch({
          modalOpen: !0
        }), r({
          mslayer_element_data_id: s.HEADER_BOOKMARKS_OPEN,
          mslayer_element_text: "öffnen",
          mslayer_element_type_text: "Merkliste",
          mslayer_element_count: e,
          mslayer_element_variant: "default",
          mslayer_element_body_type: "contentseite",
          mslayer_element_position: e,
          mslayer_element_id: e,
          mslayer_element_company_name: e,
          mslayer_element_detail_start_date: e
        });
      },
      hasDot: n
    };
  }
});
export {
  O as default
};
